import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MenuMain from "../components/MenuMain";



function Menu(){
    return(
        <>
        <Header />
        <MenuMain/>
        <Footer />
        </>
);
}

export default Menu; 